import { Button } from "@chakra-ui/react";
import { ConnectKitButton } from "connectkit";

export const CustomConnectkitButtonMobile = () => {
  return (
    <ConnectKitButton.Custom>
      {({ isConnected, show, truncatedAddress, ensName }) => {
        return (
          <Button width="80px" onClick={show}>
            {isConnected ? ensName ?? truncatedAddress : "Connect"}
          </Button>
        );
      }}
    </ConnectKitButton.Custom>
  );
};
